export default "__VITE_ASSET__CfmL_0af__"